import { TopToolbar, usePermissions, useTranslate } from 'react-admin';
import { CustomSelectColumnsButton } from '@/components/global/buttons/CustomSelectColumnsButton.jsx';
import ColumnsIcon from '@/assets/icons/columns-icon.svg?react';
import { SearchFilterInput } from '@/components/global/filters/SearchFilterInput';
import { PeriodFilterInput } from '@/components/global/filters/PeriodFilterInput.jsx';
import CustomToolbarActionsPopover from '@/components/global/buttons/CustomToolbarActionsPopover.jsx';
import CustomCreateButton from '@/components/global/buttons/CustomCreateButton.jsx';
import CustomExportButton from '@/components/global/buttons/CustomExportButton.jsx';
import CustomFilterButton from '@/components/global/filters/CustomFilterButton';
import CachedDataActionButton from '@/components/global/buttons/CachedDataActionButton.jsx';

const GroupListActions = () => {
    const { permissions } = usePermissions();
    const translate = useTranslate();

    return (
        <TopToolbar>
            <SearchFilterInput />
            <PeriodFilterInput />
            <CustomFilterButton />
            <CustomSelectColumnsButton startIcon={<ColumnsIcon />} style={{ margin: '0px -4px' }} />
            <CustomToolbarActionsPopover>
                {permissions.isAdmin ? <CustomCreateButton label={translate('resources.deviceGroup.labels.createDeviceGroup')} /> : null}
                <CustomExportButton label={translate('common.exportCsv')} />
                {permissions.isAdmin && <CachedDataActionButton resource='device-group' type={null} />}
            </CustomToolbarActionsPopover>
        </TopToolbar>
    );
};

export default GroupListActions;
